import PropTypes from 'prop-types';
import { getTokensPropType, variantProp } from '../utils';
const propTypes = {
  /**
   * Used to render the control (i.e. tooltip trigger). If a render function is used it will receive the
   * pressable state and tooltip variant as an argument.
   */
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

  /**
   * The message. Can be raw text or text components.
   */
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /**
   * Select English or French copy for the accessible label.
   */
  copy: PropTypes.oneOf(['en', 'fr']),

  /**
   * Use to place the tooltip in a specific location (only if it fits within viewport).
   */
  position: PropTypes.oneOf(['auto', 'above', 'right', 'below', 'left']),
  tokens: getTokensPropType('Tooltip'),
  variant: variantProp.propType
};
export default propTypes;